import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import {
  ReportCountByQuestionRequest,
  ReportCountByQuestionResponse,
  ReportSummaryRequest,
  ReportSummaryResponse,
} from "./types";

export const reportSummaryService = (params: ReportSummaryRequest) =>
  RestAPIClient.call<ReportSummaryResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.Summary,
    config: {
      params,
      requireAuthentication: true,
    },
  });

export const reportCountByQuestionService = (
  params: ReportCountByQuestionRequest
) =>
  RestAPIClient.call<ReportCountByQuestionResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.CountByQuestion,
    config: {
      params,
      requireAuthentication: true,
    },
  });
